import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParachute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconParachute"><Path fillRule="evenodd" clipRule="evenodd" d="M15 19.3734V22H9V19.3734L1 13.5067V13C1 6.92487 5.92487 2 12 2C18.0751 2 23 6.92487 23 13V13.5067L15 19.3734ZM13 10.4841C15.3421 10.6692 17.7313 11.507 20.2436 13.048L15 16.8933V16H13V10.4841ZM11 10.4841V16H9V16.8933L3.7564 13.048C6.26867 11.507 8.65788 10.6692 11 10.4841Z" fill="currentColor"/></CentralIconBase>;
});

export default IconParachute;
